import React, {Fragment, useEffect, useState} from 'react';
import {Translate} from "../../lang/lang";
import {useSelector} from "react-redux";
import {selectLang} from "../../store/reducers/main/main";
import classNames from "classnames";
import {WITHOUT_VAT_PRIVILEGE_TYPE, ZERO_VAT_PRIVILEGE_TYPE} from "../../enum/roaming/LgotaTypes";
import {Col, Modal, OverlayTrigger, Row, Tooltip, Form} from "react-bootstrap";
import ReactSelect from "react-select";
import Divider from "./Divider";
import IconButton from "../IconButton";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import CustomFloatingLabelSelect from "../floating-custom-select/CustomFloatingLabelSelect";

const BenefitLinkSelector = ({onChange, benefits, defaultBenefit, linkProps}) => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const [show, setShow] = useState(false);
    const [benefit, setBenefit] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);

    const link = <span onClick={() => setShow(true)}
                       className={classNames('fs--1 cursor-pointer', {
                           'text-success': benefit?.type === ZERO_VAT_PRIVILEGE_TYPE,
                           'text-primary': benefit?.type === WITHOUT_VAT_PRIVILEGE_TYPE
                       })}
                       {...linkProps}
    >
        {benefit ? `${benefit.new_id || benefit.id}` : t(lang, 'items.common.click_to_select_benefit')}
    </span>

    const onChangeHandler = (option) => {
        setBenefit(option);
        onChange(option);
        option && setShow(false);
    }

    useEffect(() => {
        if (defaultBenefit?.new_id !== benefit?.new_id || defaultBenefit?.id !== benefit?.id)
            setBenefit(defaultBenefit);
    }, [defaultBenefit, benefits])

    const formatOptionLabel = (option) => {
        return (
            <div className="fs--1">
                <h5 className="fs--1 fw-bold">
                    {option.type === 1 &&
                        <span className="text-success">{t(lang, "edi.common.privilege.type.1")}</span>}
                    {option.type === 2 &&
                        <span className="text-primary">{t(lang, "edi.common.privilege.type.2")}</span>}
                </h5>
                <p>
                    <span className="text-success fw-bold me-1">{option.new_id};</span>
                    <span className="text-warning fw-bold me-1">{option.id}</span>-
                    <span className="ms-1 text-facebook">{option.name}</span>
                </p>
            </div>
        )
    };

    return (
        <Fragment>
            {benefit && <OverlayTrigger overlay={<Tooltip>{benefit.name}</Tooltip>}>
                {link}
            </OverlayTrigger>}
            {!benefit && link}
            <Modal show={show}
                   onHide={() => setShow(false)}
                   size="xl"
                   aria-labelledby="contained-modal-title-vcenter"
                   centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t(lang, 'items.common.benefit_link_selector_modal.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col xs={12}>
                            <Form.Group>
                                <CustomFloatingLabelSelect
                                    options={benefits}
                                    isClearable
                                    hideSelectedOptions
                                    defaultMenuIsOpen={!benefit}
                                    formatOptionLabel={formatOptionLabel}
                                    getOptionLabel={option => option.name}
                                    getOptionValue={option => option.new_id || option.id}
                                    placeholder={t(lang, "")}
                                    value={null}
                                    onChange={onChangeHandler}
                                    label={t(lang, 'items.common.benefit')}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {benefit &&
                        <>
                            <Divider/>
                            <Row>
                                <Col xs={12}>
                                    <h5 className="text-info">{t(lang, 'items.common.benefit_link_selector.chosen_benefit')}</h5>
                                    <div className="mt-3 fw-bold fs--1">
                                        <span className="text-primary">{benefit.new_id || benefit.id}</span> |
                                        <span className="text-dark">{benefit.name}</span>
                                        <IconButton
                                            variant="phoenix-secondary"
                                            size="sm"
                                            icon={faTrash}
                                            iconClassName={"text-danger"}
                                            className="ms-2 fw-semi-bold"
                                            title={t(lang, 'items.common.delete')}
                                            onClick={() => onChangeHandler(null)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </>
                    }
                </Modal.Body>
            </Modal>
        </Fragment>
    );
};

export default BenefitLinkSelector;
